module.exports = "<label ng-show=\"label\">{{label}}</label>\n<div class=\"toggleswitch display-inline-block\">\n    <input type=\"checkbox\" name=\"toggleswitch\" class=\"toggleswitch-checkbox\"\n           id=\"{{id}}\"\n           ng-model=\"ngModel\"\n           ng-change=\"ngChange()\"\n           ng-click=\"ngClick()\"\n           ng-disabled=\"ngDisabled\">\n    <label class=\"toggleswitch-label\" for=\"{{id}}\">\n        <div class=\"toggleswitch-inner\"></div>\n        <div class=\"toggleswitch-switch\"></div>\n    </label>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/directives/forms/toggle_switch.html
// module id = 194
// module chunks = 0